import { render } from "./Registration.vue?vue&type=template&id=6780d6ef&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=ts"
export * from "./Registration.vue?vue&type=script&lang=ts"

import "./Registration.vue?vue&type=style&index=0&id=6780d6ef&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6780d6ef"

export default script